import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from '../useMutationApi';

// Delete rebate agreement
export const useDeleteRebateAgreement = (agreementId: string) => {
  const queryClient = useQueryClient();

  return useMutationApi<void, void>({
    endpoint: `rebates/agreements/${agreementId}`,
    method: 'DELETE',
    options: {
      onSuccess: () => {
        // Invalidate rebate agreements queries to refresh the data
        queryClient.invalidateQueries({ queryKey: ['rebateAgreements'] });
        queryClient.invalidateQueries({ queryKey: ['rebateAgreement'] });
      },
    },
    successMessage: 'Rebate agreement deleted successfully',
  });
};

export default useDeleteRebateAgreement;
